import { render, staticRenderFns } from "./CalendarCard.vue?vue&type=template&id=d8887cde&scoped=true"
import script from "./CalendarCard.vue?vue&type=script&lang=ts"
export * from "./CalendarCard.vue?vue&type=script&lang=ts"
import style0 from "./CalendarCard.vue?vue&type=style&index=0&id=d8887cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8887cde",
  null
  
)

export default component.exports